import { useState } from "react";
import { Box, Popover, Typography, Stack, Card } from "@mui/material";
import emoji from "emoji-dictionary";

const WinWireReaction = ({ allReactions, reaction, count, userReaction, handleReactionClick }) => {
  const className = `reaction-emoji ${userReaction ? "user-reaction" : ""}`;
  const [anchorEl, setAnchorEl] = useState(null);
  const tooltipOpen = Boolean(anchorEl);

  const handleTooltipOpen = (event) => {
    if (event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleTooltipClose = () => {
    setAnchorEl(null);
  };

  const getTooltipContent = () => (
    <Box sx={{ pb: "0.5rem" }}>
      <Card
        sx={{
          p: 2,
          backgroundColor: "#19191b",
          border: "1px solid #333",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          maxWidth: "500px",
          maxHeight: "120px",
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
          <Stack alignItems="center" justifyContent="center">
            <Box fontSize="2rem">{emoji.getUnicode(reaction)}</Box>
            <Typography sx={{ fontSize: "0.8rem", color: "#888", lineHeight: "0.5rem" }}>
              {reaction}
            </Typography>
          </Stack>
          <Box sx={{ maxHeight: "86px", overflow: "auto" }}>
            <Typography sx={{ fontSize: "0.9rem", color: "#ddd9d5" }}>
              {"Reaction by "}
              {allReactions
                .filter((r) => r.reaction === reaction)
                .map((r) => r.UserCompaniesLink?.name)
                .filter(Boolean)
                .join(", ")}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Box>
  );

  return (
    <Box onMouseEnter={(e) => handleTooltipOpen(e)} onMouseLeave={handleTooltipClose}>
      <Box
        className={className}
        role="img"
        aria-label={reaction}
        onClick={() => handleReactionClick(reaction)}
      >
        {emoji.getUnicode(reaction)}
        {count && <Typography sx={{ ml: "0.25rem", fontSize: "0.8rem" }}>{count}</Typography>}
      </Box>
      {tooltipOpen && (
        <Popover
          open={tooltipOpen}
          anchorEl={anchorEl}
          onClose={handleTooltipClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          sx={{
            "& .MuiPopover-paper": {
              p: 0,
            },
            pointerEvents: "none",
          }}
          PaperProps={{
            sx: {
              pointerEvents: "auto",
              boxShadow: "none",
            },
          }}
        >
          {getTooltipContent()}
        </Popover>
      )}
    </Box>
  );
};

export default WinWireReaction;
